
import { computed, defineComponent, ref, watch, PropType } from 'vue'
import isNil from 'lodash/isNil'
import moment from 'moment'
import BaseInputOutlined from '../inputs/BaseInputOutlined.vue'

export default defineComponent({
    components: { BaseInputOutlined },
    props: {
        value: { type: [String, Array] as PropType<string | string[]> },
        label: { type: String, default: null },
        dateFormat: { type: String, default: 'DD.MM.YYYY' },
        range: { type: Boolean, default: false },
        clearable: { type: Boolean, default: true },
        hideDetails: { type: Boolean, default: false },
        hint: { type: String, default: '' },
        persistentHint: { type: Boolean, default: false },
        rules: { type: Array, default: () => [] },
        placeholder: { type: String, default: '' },
    },
    setup(props, { emit }) {
        const DATE_PICKER_DATE_FORMAT = 'YYYY-MM-DD'
        const menuIsOpened = ref(false)
        const internalDates = ref(props.value)

        watch(() => props.value, (newVal) => {
            internalDates.value = newVal
        }, { immediate: true })

        const appendIcon = computed(() => {
            if (!props.clearable) return null
            return 'mdi-close'
        })

        const dateText = computed(() => {
            let datesToFormat = internalDates.value
            
            if (Array.isArray(datesToFormat)) {
                const sortedDates = [...datesToFormat].sort(
                    (a, b) =>
                        moment(a, DATE_PICKER_DATE_FORMAT).unix() -
                        moment(b, DATE_PICKER_DATE_FORMAT).unix()
                )
                
                const formatedDates = sortedDates.map(date =>
                    isNil(date) ? '' : moment(date, DATE_PICKER_DATE_FORMAT).format(props.dateFormat)
                )
                return formatedDates.join(' - ')
            } else {
                return isNil(datesToFormat)
                    ? ''
                    : moment(datesToFormat, DATE_PICKER_DATE_FORMAT).format(props.dateFormat)
            }
        })

        const onDatePickerInput = (value: any) => {
            console.log('DatePicker emitting:', value);
            internalDates.value = value;
            emit('input', value);
        }

        const closeMenu = () => {
            menuIsOpened.value = false;
        }

        const clear = () => {
            if (!props.clearable) return;
            internalDates.value = null;
            emit('input', null);
        }

        return { 
            menuIsOpened, 
            internalDates,
            dateText, 
            closeMenu, 
            clear, 
            appendIcon,
            onDatePickerInput
        }
    },
})
